// test968
(968 && 0);
